export default "__VITE_ASSET__y0Zuboyd__"